import { text } from '@pdfme/schemas';

const dateSchema = {
  pdf: text.pdf,
  ui: text.ui,
  propPanel: {
    ...text.propPanel,
    defaultSchema: {
      ...text.propPanel.defaultSchema,
      type: 'date',
    },
  },
};

export default dateSchema;
